<template>
  <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M13 3L3 13M3 3L13 13" stroke="#FF0000" stroke-width="1.2" stroke-linecap="round" stroke-linejoin="round" />
  </svg>
</template>
